import * as Sentry from '@sentry/react';

import type { StudioDetails } from '~entities/studios/model/types';
import type { UserWithRole } from '~entities/users/model/types';

/**
 * Attach (or clear) the authenticated user as global Sentry context. Once set,
 * every event — automatic (ErrorBoundary, query/axios) or manual (reportError)
 * — is attributable to a user.
 */
export function setSentryUserContext(
  user: UserWithRole | null | undefined,
): void {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({ id: user.id, email: user.email });
}

/**
 * Attach (or clear) the current studio as global Sentry context + tag, so
 * issues are filterable by studio.
 */
export function setSentryStudioContext(
  studio: StudioDetails | null | undefined,
): void {
  if (!studio) {
    Sentry.setContext('studio', null);
    Sentry.setTag('studioId', undefined);
    return;
  }

  Sentry.setContext('studio', {
    studioId: studio._id,
    studioName: studio.subaccountName,
    locationId: studio.locationId,
    companyId: studio.companyId,
  });
  Sentry.setTag('studioId', studio._id);
}
